import './Button.scss';

function Button({text, href}) {
    return (
        <div className='button'>
            <a className="button__link" target="_blank" href={href}>
                {text}
            </a>
        </div>
    )
}
export default Button;